<template>
  <div>
    <h1>Error</h1>
    <div>{{ $route.query.error }}</div>
    <div>{{ $route.query.error_description }}</div>

  </div>
</template>